const t = "720px", p = "1024px";
export {
  t as phablet,
  p as tablet
};
